import React from "react";

type OrderWrapperProps = {
  children: React.ReactNode;
  /**
   * Drop the reading-width cap so the card fills its container. Used by the
   * admin portal, where dense tables need the whole screen; customer-facing
   * pages stay capped at max-w-5xl for readability.
   */
  wide?: boolean;
};

const OrderWrapper = ({ children, wide }: OrderWrapperProps) => {
  return (
    <div className={`w-full ${wide ? "" : "max-w-5xl mx-auto"}`}>
      <div className="flex flex-col gap-4 bg-cream-light border border-accent p-6 rounded-xl shadow-md w-full h-min">
        {children}
      </div>
    </div>
  );
};

export default OrderWrapper;
